import React from 'react'

export default function ProductsFurniture() {
  return (
    <div>
      
    </div>
  )
}
